var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "feedback-box dark-mode" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Rate your image"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted font-weight-bold" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex feedback-thumbs" }, [
      _c("div", { staticClass: "w-100" }, [
        _c(
          "div",
          {
            staticClass: "feedback-btn w-100",
            class: {
              disabled: this.isRatedUp() === true,
              active: this.isRatedUp() === true,
            },
            on: { click: _vm.thumbsUp },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c(
                  "path",
                  {
                    attrs: {
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-dasharray": "80",
                      "stroke-dashoffset": "80",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M7 11L12 3L15 4L14 10H21V13L18 20H7H3V11H7V20",
                    },
                  },
                  [
                    _c("animate", {
                      attrs: {
                        fill: "freeze",
                        attributeName: "stroke-dashoffset",
                        dur: "0.8s",
                        values: "80;0",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(
              "\n        " + _vm._s(_vm._f("trans")("Good result")) + "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-100" }, [
        _c(
          "div",
          {
            staticClass: "feedback-btn w-100",
            class: {
              disabled: this.isRatedDown() === true,
              active: this.isRatedDown() === true,
            },
            on: { click: _vm.thumbsDown },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c(
                  "path",
                  {
                    attrs: {
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-dasharray": "80",
                      "stroke-dashoffset": "80",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M7 4H18L21 11V14H14L15 20L12 21L7 13H3V4H7V13",
                    },
                  },
                  [
                    _c("animate", {
                      attrs: {
                        fill: "freeze",
                        attributeName: "stroke-dashoffset",
                        dur: "0.8s",
                        values: "80;0",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("trans")("Not satisfied")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }